define("settings/controllers/groups/trade", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/array", "@ember/controller", "@ember/service", "@ember/utils", "@glimmer/tracking", "ember-concurrency", "lodash", "shared/utils/object-promise-proxy"], function (_exports, _asyncArrowRuntime, _array, _controller, _service, _utils, _tracking, _emberConcurrency, _lodash, _objectPromiseProxy) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _disableLinkinbioForSocialProfilesMovedBetweenGroups, _doesProfileHaveLinkinbioFeed, _getFormattedGroups, _getFormattedIdentities, _getFormattedSocialProfiles, _getLinkinbioDescription;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/array",0,"@ember/controller",0,"@ember/service",0,"@ember/utils",0,"@glimmer/tracking",0,"ember-concurrency",0,"lodash",0,"shared/utils/object-promise-proxy"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let TradeController = _exports.default = (_class = (_disableLinkinbioForSocialProfilesMovedBetweenGroups = /*#__PURE__*/new WeakSet(), _doesProfileHaveLinkinbioFeed = /*#__PURE__*/new WeakSet(), _getFormattedGroups = /*#__PURE__*/new WeakSet(), _getFormattedIdentities = /*#__PURE__*/new WeakSet(), _getFormattedSocialProfiles = /*#__PURE__*/new WeakSet(), _getLinkinbioDescription = /*#__PURE__*/new WeakSet(), class TradeController extends _controller.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _getLinkinbioDescription);
      _classPrivateMethodInitSpec(this, _getFormattedSocialProfiles);
      _classPrivateMethodInitSpec(this, _getFormattedIdentities);
      _classPrivateMethodInitSpec(this, _getFormattedGroups);
      _classPrivateMethodInitSpec(this, _doesProfileHaveLinkinbioFeed);
      _classPrivateMethodInitSpec(this, _disableLinkinbioForSocialProfilesMovedBetweenGroups);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor3, this);
      _initializerDefineProperty(this, "errors", _descriptor4, this);
      _initializerDefineProperty(this, "segment", _descriptor5, this);
      _initializerDefineProperty(this, "intl", _descriptor6, this);
      _initializerDefineProperty(this, "router", _descriptor7, this);
      _initializerDefineProperty(this, "store", _descriptor8, this);
      _initializerDefineProperty(this, "movedSocialProfiles", _descriptor9, this);
      _initializerDefineProperty(this, "movedSocialIdentities", _descriptor10, this);
      _initializerDefineProperty(this, "profilesMovedBetweenGroups", _descriptor11, this);
      _defineProperty(this, "confirmMove", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function (incomingProfiles, didMoveProfilesBetweenGroups) {
          var _this = this;
          let outgoingProfile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
          return function* () {
            const profilesWithLinkinbioFeed = [];
            const creatorProfiles = [];
            const doesOutgoingProfileHaveLinkinbioFeed = _classPrivateMethodGet(_this, _doesProfileHaveLinkinbioFeed, _doesProfileHaveLinkinbioFeed2).call(_this, outgoingProfile);
            incomingProfiles.forEach(profile => {
              if (_classPrivateMethodGet(_this, _doesProfileHaveLinkinbioFeed, _doesProfileHaveLinkinbioFeed2).call(_this, profile)) {
                profilesWithLinkinbioFeed.push(profile);
              }
              if (profile.get('socialIdentity.influencerId')) {
                creatorProfiles.push(profile);
              }
            });
            const shouldConfirmMove = didMoveProfilesBetweenGroups || profilesWithLinkinbioFeed.length || creatorProfiles.length || doesOutgoingProfileHaveLinkinbioFeed;
            return shouldConfirmMove ? yield _this.dialogManager.confirmation(_this.intl.t('account.groups.group.social_profiles.move.confirm_title', {
              count: incomingProfiles.length
            }), {
              description: yield _this.getConfirmationDescription.perform(profilesWithLinkinbioFeed, creatorProfiles, doesOutgoingProfileHaveLinkinbioFeed ? outgoingProfile : undefined),
              confirmButton: _this.intl.t('account.groups.group.social_profiles.move.confirm_button')
            }) : true;
          }();
        }
      }), {
        drop: true
      }, "confirmMove", null));
      _defineProperty(this, "getConfirmationDescription", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (profilesWithLinkinbioFeed, creatorProfiles, outgoingProfileWithLinkinbioFeed) {
          const confirmMoveDescription = this.intl.t('account.groups.group.social_profiles.move.confirm');
          if ((0, _utils.isEmpty)(profilesWithLinkinbioFeed) && (0, _utils.isEmpty)(creatorProfiles) && (0, _utils.isEmpty)(outgoingProfileWithLinkinbioFeed)) {
            return confirmMoveDescription;
          }
          const linkinbioDescription = _classPrivateMethodGet(this, _getLinkinbioDescription, _getLinkinbioDescription2).call(this, profilesWithLinkinbioFeed, outgoingProfileWithLinkinbioFeed);
          const creatorDescription = yield this.getCreatorDescription.perform(linkinbioDescription, creatorProfiles);
          return creatorDescription.concat('<br><br>', confirmMoveDescription);
        }
      }), null, "getConfirmationDescription", null));
      _defineProperty(this, "getCreatorDescription", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function () {
          var _this2 = this;
          let linkinbioDescription = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
          let creatorProfiles = arguments.length > 1 ? arguments[1] : undefined;
          return function* () {
            try {
              if (_this2.canAccessOCE && (0, _utils.isPresent)(creatorProfiles)) {
                let creatorDescription = _this2.intl.t('account.groups.group.social_profiles.move.confirm_creator_applicant');
                let campaigns = [];
                const hasRequiredProfile = (0, _utils.isPresent)(creatorProfiles.filter(socialProfile => socialProfile.isInstagram || socialProfile.isFacebook));
                const resolvedInfluencers = yield Promise.all(creatorProfiles.map(socialProfile => (0, _objectPromiseProxy.default)(socialProfile.get('socialIdentity.influencer'))));
                const influencers = (0, _lodash.uniqBy)(resolvedInfluencers, 'id');
                for (const influencer of influencers) {
                  const active = yield influencer.manageCampaigns({
                    status: 'active'
                  });
                  const applied = yield influencer.manageCampaigns({
                    status: 'applied'
                  });
                  campaigns = [...campaigns, ...active.campaign, ...applied.campaign];
                }
                campaigns = campaigns.flat();
                if (hasRequiredProfile) {
                  creatorDescription = creatorDescription.concat('<br><br>', _this2.intl.t('account.groups.group.social_profiles.move.confirm_creator_profile'));
                }
                if ((0, _utils.isPresent)(campaigns)) {
                  creatorDescription = creatorDescription.concat('<br><br>', _this2.intl.t('account.groups.group.social_profiles.move.confirm_creator_required_applicant'));
                }
                return (0, _utils.isPresent)(linkinbioDescription) ? linkinbioDescription.concat('<br/><br/>', creatorDescription) : creatorDescription;
              }
              return linkinbioDescription;
            } catch (error) {
              _this2.errors.log(error);
            }
          }();
        }
      }), null, "getCreatorDescription", null));
      _defineProperty(this, "saveChanges", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          //created group is necessary for collectionAction - Ian K
          const tempGroup = this.store.createRecord('group');
          const groups = {
            groups: _classPrivateMethodGet(this, _getFormattedGroups, _getFormattedGroups2).call(this)
          };
          const response = yield tempGroup.rearrange(groups);
          this.store.pushPayload(response);
          _classPrivateMethodGet(this, _disableLinkinbioForSocialProfilesMovedBetweenGroups, _disableLinkinbioForSocialProfilesMovedBetweenGroups2).call(this);
          yield tempGroup.destroyRecord();
          this.trackChangesInSegment();
          this.alerts.success(this.intl.t('alerts.account.groups.group.social_profiles.move.update_success'));
          this.router.transitionTo('account.groups');
        }
      }), null, "saveChanges", null));
      _defineProperty(this, "trackGroupTrade", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function (_ref) {
          var _this3 = this;
          let {
            identity
          } = _ref;
          return function* () {
            const didMoveProfilesBetweenGroups = identity.socialProfiles.length > 0;
            const didConfirm = _this3.confirmMove.perform(identity.socialProfiles, didMoveProfilesBetweenGroups);
            if (didConfirm) {
              _this3.movedSocialIdentities.addObject(identity);
              identity.socialProfiles.forEach(profile => {
                _this3.movedSocialProfiles.addObject(profile);
                _this3.profilesMovedBetweenGroups.addObject(profile);
              });
            }
            return didConfirm;
          }();
        }
      }), null, "trackGroupTrade", null));
      _defineProperty(this, "trackProfileTrade", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function (_ref2, didMoveProfileBetweenGroups, _ref3) {
          var _this4 = this;
          let {
            profile: incomingProfile
          } = _ref2;
          let {
            profile: outgoingProfile
          } = _ref3;
          return function* () {
            if (incomingProfile) {
              const didConfirm = yield _this4.confirmMove.perform([incomingProfile], didMoveProfileBetweenGroups, outgoingProfile);
              if (didConfirm) {
                _this4.movedSocialProfiles.addObject(incomingProfile);
                if (didMoveProfileBetweenGroups) {
                  _this4.profilesMovedBetweenGroups.addObject(incomingProfile);
                }
              }
              return didConfirm;
            }
          }();
        }
      }), null, "trackProfileTrade", null));
    }
    get lastGroup() {
      return this.auth.lastGroup;
    }
    get movedSocialProfilesCount() {
      return this.movedSocialProfiles.length;
    }
    get movedSocialIdentitiesCount() {
      return this.movedSocialIdentities.length;
    }
    get movedSocialProfileTypes() {
      return this.movedSocialProfiles.map(profile => profile.profileType);
    }
    get movedSocialProfileNicknames() {
      return this.movedSocialProfiles.map(profile => profile.nickname);
    }
    get movedSocialProfileIds() {
      return this.movedSocialProfiles.map(profile => profile.id);
    }
    get canAccessOCE() {
      return this.auth.currentAccount.rolloutOcePhase1;
    }
    trackChangesInSegment() {
      this.segment.track('moved-social-profile', {
        moved_social_set: this.movedSocialIdentitiesCount,
        moved_social_profile: this.movedSocialProfilesCount,
        profile_types: this.movedSocialProfileTypes,
        profile_nicknames: this.movedSocialProfileNicknames,
        profile_ids: this.movedSocialProfileIds
      }, {
        user: 'currentUserModel.id'
      });
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "movedSocialProfiles", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return (0, _array.A)();
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "movedSocialIdentities", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return (0, _array.A)();
    }
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "profilesMovedBetweenGroups", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return (0, _array.A)();
    }
  })), _class);
  function _disableLinkinbioForSocialProfilesMovedBetweenGroups2() {
    this.profilesMovedBetweenGroups.forEach(profile => {
      profile.setProperties({
        linkinbioEnabled: false
      });
    });
  }
  function _doesProfileHaveLinkinbioFeed2(profile) {
    return Boolean(profile?.get('linkinbioPage'));
  }
  function _getFormattedGroups2() {
    return this.groups.map(group => {
      return {
        id: group.id,
        social_identities: _classPrivateMethodGet(this, _getFormattedIdentities, _getFormattedIdentities2).call(this, group)
      };
    });
  }
  function _getFormattedIdentities2(group) {
    return (0, _utils.isEmpty)(group.temporaryIdentities) && group.traded !== true ? group.socialIdentities.filter(identity => identity.id).map(identity => {
      return {
        id: identity.id,
        social_profiles: _classPrivateMethodGet(this, _getFormattedSocialProfiles, _getFormattedSocialProfiles2).call(this, identity)
      };
    }) : group.temporaryIdentities.filter(tempIdentity => tempIdentity.identity).map(tempIdentity => {
      return {
        id: tempIdentity.identity.id,
        social_profiles: _classPrivateMethodGet(this, _getFormattedSocialProfiles, _getFormattedSocialProfiles2).call(this, tempIdentity.identity)
      };
    });
  }
  function _getFormattedSocialProfiles2(identity) {
    return (0, _utils.isEmpty)(identity.temporaryProfiles) ? identity.socialProfiles.filter(profile => profile).map(profile => {
      return {
        id: profile.id
      };
    }) : identity.temporaryProfiles.filter(tempProfile => tempProfile.profile).map(tempProfile => {
      return {
        id: tempProfile.profile.id
      };
    });
  }
  function _getLinkinbioDescription2(profilesWithLinkinbioFeed, outgoingProfileWithLinkinbio) {
    const profilesWithFeed = profilesWithLinkinbioFeed;
    if (outgoingProfileWithLinkinbio) {
      profilesWithFeed.push(outgoingProfileWithLinkinbio);
    }
    //Note: structure is {'urlName': [{platform: 'platform', name: 'name'}]}
    const pagesWithFeed = {};
    profilesWithFeed.forEach(profile => {
      const url = profile.get('linkinbioPage.urlName');
      const config = {
        platform: profile.localizedAccountType,
        name: profile.displayNickname
      };
      if (Object.prototype.hasOwnProperty.call(pagesWithFeed, url)) {
        pagesWithFeed[url].push(config);
      } else {
        pagesWithFeed[url] = [config];
      }
    });
    let message = '';
    Object.keys(pagesWithFeed).forEach((pageName, index) => {
      let pageMessage = '';
      const profiles = pagesWithFeed[pageName];
      profiles.forEach(profile => {
        if (pageMessage) {
          pageMessage += ` ${this.intl.t('account.groups.group.social_profiles.move.confirm_linkinbio_enabled_additional', {
            platform: profile.platform,
            name: profile.name
          })}`;
        } else {
          if (index != 0) {
            pageMessage += `<br><br>`;
          }
          pageMessage += `${this.intl.t('account.groups.group.social_profiles.move.confirm_linkinbio_enabled', {
            url: pageName,
            platform: profile.platform,
            name: profile.name
          })}`;
        }
      });
      message += `${pageMessage}.`;
    });
    return message;
  }
});